export const recipientComponentTypes = Object.freeze({
  PHONE_NUMBER: 'PhoneNumber',
  EMAIL_ADDRESS: 'EmailAddress',
});

export type GenericComponent = 'PhoneNumber' | 'EmailAddress';
